module.exports = __webpack_public_path__ + "static/img/34.7cbd9ae8.jpeg";